import React from 'react'
import { formatPostDate } from '../../../../Utils/StayUpToDate/RenderComponent'
const PostInfoDate = (props:any) => {
    const {post_date} = props
  return (
    <>
     {new Date(post_date).getFullYear() > 2000 ? (
          <p className="creator-feed-content-date">
            {formatPostDate(post_date)}
          </p>
        ) : (
          ""
        )}
    
    </>
  )
}

export default PostInfoDate